export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
          {/* Left Visual */}
          <div className="flex-shrink-0 w-full lg:w-[380px]">
            <div className="relative aspect-[3/4] max-w-[260px] mx-auto rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20mobile%20phone%20mockup%20displaying%20anime%20streaming%20app%20interface%20with%20colorful%20anime%20thumbnails%20in%20grid%20layout%2C%20clean%20dark%20UI%20design%20with%20warm%20orange%20accent%20color%2C%20sleek%20minimal%20app%20design%2C%20video%20player%20interface%2C%20no%20text%20no%20watermark&width=520&height=693&seq=app-mockup-01&orientation=portrait"
                alt="6080影视移动端追番界面展示"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) target.parentElement.style.display = 'none';
                }}
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">移动追番，随时随地</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5">
              6080影视移动端完美适配手机和平板，无论你在通勤路上、午休时间还是被窝里，
              打开浏览器就能畅享高清动漫番剧。流畅的触控交互和智能省流模式，
              让移动追番体验不输桌面端。支持横竖屏切换，躺着追番也毫无压力。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3 mb-5">
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold">
                <i className="ri-smartphone-line" style={{ width: '1em', height: '1em' }}></i>
                手机浏览器直接访问
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
                <i className="ri-fullscreen-line" style={{ width: '1em', height: '1em' }}></i>
                横竖屏自由切换
              </span>
              <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold">
                <i className="ri-wifi-line" style={{ width: '1em', height: '1em' }}></i>
                省流模式流畅观看
              </span>
            </div>
            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold transition-colors hover:bg-primary-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line" style={{ width: '1em', height: '1em' }}></i>
              立即体验移动追番
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}